import { useCallback } from "react";

import { Photos } from "@/types/common/photos";

type Props = {
  media?: Photos[] | undefined;
  currentIndex: number | undefined;
  isZendesk?: boolean;
  afterChange?: (index: number) => void;
  itemWidth?: number;
  margin?: number;
  children?: React.ReactNode;
};

const SimpleSlider = ({
  media,
  currentIndex = 0,
  children,
  itemWidth,
  margin
}: Props) => {
  const sliderItemWidth = itemWidth ? itemWidth : 100;
  const itemMargin = margin ? margin : 8;

  /** bottomSlider用 選択時のX方向スライド位置を計算する */
  const translateX = useCallback(() => {
    const containerWidth =
      (sliderItemWidth + itemMargin) * (media ? media.length : 1);

    if (window.innerWidth > containerWidth) {
      return 0;
    }

    const translateX =
      ((containerWidth - window.innerWidth) * currentIndex) /
      (media && media.length > 1 ? media.length - 1 : 1);

    return translateX;
  }, [media, currentIndex, itemMargin, itemWidth]);

  return (
    <div className="m-auto overflow-hidden">
      {/* container */}
      <div
        className={`whitespace-nowrap duration-500`}
        style={{ translate: `-${translateX()}px 0` }}
      >
        {children}
      </div>
    </div>
  );
};

export default SimpleSlider;
